<template>
  <div class="ltt-modal" v-show="isShow" @touchmove.stop.prevent="">
    <div class="ltt-modal-content" :class="{'has-button': isShowConfirmButton || isShowCancelButton}">
      <slot></slot>
      <div class="ltt-modal-button-area">
        <div class="ltt-modal-confirm-button" :class="{'two-button': isShowConfirmButton && isShowCancelButton}" v-if="isShowConfirmButton" @click="clickConfirm">{{confirmButtonWord}}</div>
        <div class="ltt-modal-cancel-button" :class="{'two-button': isShowConfirmButton && isShowCancelButton}" @click="close" v-if="isShowCancelButton">{{cancelButtonWord}}</div>
      </div>
      <div class="ltt-modal-close-button" @click="close">
        <img width="100%" src="https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/resources/images/icons/close_button.png">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ltt-modal",
  props: {
    isShowConfirmButton: {
      default: true
    },
    isShowCancelButton: {
      default: false
    },
    confirmButtonWord: {
      default: '确认'
    },
    cancelButtonWord: {
      default: '取消'
    },
  },
  data() {
    return {
      //是否显示
      isShow: false
    }
  },
  methods: {
    //显示
    show() {
      this.isShow = true
    },
    open() {
      this.isShow = true
    },
    //关闭弹窗
    close() {
      this.isShow = false
    },
    /**
     * 点击确认按钮
     */
    clickConfirm() {
      this.close()
      this.$emit('confirm')
    },
  }
}
</script>

<style scoped lang="less">
.ltt-modal {
  z-index: 99;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(#000000, .4);
  .ltt-modal-content {
    position: relative;
    box-sizing: border-box;
    min-width: 582px;
    padding: 40px 30px;
    margin: 80px;
    background: #FFFFFF;
    border-radius: 36px;
    .ltt-modal-button-area {
      position: absolute;
      bottom: 40px;
      left: 0;
      right: 0;
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin: 0 30px;
      .ltt-modal-confirm-button,
      .ltt-modal-cancel-button {
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        width: 528px;
        height: 80px;
        padding: 0 20px;
        border-radius: 40px;
        text-align: center;
      }
      .ltt-modal-confirm-button {
        background: linear-gradient(270deg, #FF1260 0%, #FF5B91 100%);
        color: #FFFFFF;
      }
      .ltt-modal-cancel-button {
        border: 3px solid #FF1260;
        color: #FF1260;
      }
      .two-button {
        width: 220px
      }
    }
    .ltt-modal-close-button {
      position: absolute;
      bottom: -100px;
      left: 50%;
      transform: translateX(-50%);
      width: 62px;
      height: 62px;
    }
  }
  .has-button {
    padding: 40px 30px 160px;
  }
}
</style>
